// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"81":"898674e0","278":"a3e28301","405":"c01986e2","488":"f2f58a21","596":"a079426d","748":"34af6335","841":"ce0d26f7","885":"b13190cf"}[chunkId] + ".chunk.js";
};